import { jsx as _jsx, jsxs as _jsxs } from "nativewind/jsx-runtime";
import React from 'react';
import styled from 'styled-components/native';
import { SccPressable } from '@/components/SccPressable';
import { color } from '@/constant/color';
import { font } from '@/constant/font';
export var BottomSheetButtonGroupLayout;
(function (BottomSheetButtonGroupLayout) {
    BottomSheetButtonGroupLayout[BottomSheetButtonGroupLayout["HORIZONTAL"] = 0] = "HORIZONTAL";
    BottomSheetButtonGroupLayout[BottomSheetButtonGroupLayout["HORIZONTAL_1X2"] = 1] = "HORIZONTAL_1X2";
    BottomSheetButtonGroupLayout[BottomSheetButtonGroupLayout["VERTICAL"] = 2] = "VERTICAL";
})(BottomSheetButtonGroupLayout || (BottomSheetButtonGroupLayout = {}));
export default function BottomSheetButtonGroup({ layout = BottomSheetButtonGroupLayout.HORIZONTAL, positiveButton, negativeButton, }) {
    const isVertical = layout === BottomSheetButtonGroupLayout.VERTICAL;
    const isHorizontal = !isVertical;
    return (_jsxs(ButtonContainer, { style: {
            flexDirection: isHorizontal ? 'row' : 'column-reverse',
        }, children: [negativeButton && (_jsx(NegativeButton, { elementName: "bottom_sheet_negative_button", style: {
                    flex: isHorizontal ? 1 : undefined,
                }, onPress: negativeButton.onPressed, children: _jsx(NegativeButtonText, { children: negativeButton.text }) })), positiveButton && (_jsx(PositiveButton, { elementName: "bottom_sheet_positive_button", style: {
                    flex: isHorizontal
                        ? layout === BottomSheetButtonGroupLayout.HORIZONTAL_1X2
                            ? 2
                            : 1
                        : undefined,
                    marginBottom: isVertical ? 10 : undefined,
                    marginLeft: isHorizontal ? 10 : undefined,
                }, onPress: positiveButton.onPressed, children: _jsx(PositiveButtonText, { children: positiveButton.text }) }))] }));
}
const ButtonContainer = styled.View({
    padding: 20,
});
const PositiveButton = styled(SccPressable)({
    height: 56,
    borderRadius: 20,
    backgroundColor: color.brandColor,
    justifyContent: 'center',
    alignItems: 'center',
});
const PositiveButtonText = styled.Text({
    color: color.white,
    fontSize: 18,
    fontFamily: font.pretendardBold,
});
const NegativeButton = styled(SccPressable)({
    height: 56,
    borderRadius: 20,
    backgroundColor: color.gray10,
    justifyContent: 'center',
    alignItems: 'center',
});
const NegativeButtonText = styled.Text({
    color: color.black,
    fontSize: 18,
    fontFamily: font.pretendardMedium,
});
